import React from 'react';
import '../App.css';
import hamiltonLogo from '../images/hamilton-lib-logo.PNG';

// We come here after entering a name in author Search
// We also come here by authorSearch -> click letter -> click name -> here

function AuthorList () { 

  return (
      <div>
        <nav className="navbar fixed-top navbar-expand-sm navbar-light"  style={{"background-color": '#003153'}}>
        <a href="http://elib.hamilton.edu/"><img src={hamiltonLogo} alt="Hamilton logo" width="130" height="60" className = "navbar-brand" /></a>
          <button className="navbar-toggler" data-toggle="collapse" data-target="#navbarMenu">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarMenu">
            <ul className="navbar-nav ml-auto"> 
              <li className="nav-item">
                <a href="/#" className="nav-link"> Basic Search</a>
              </li>
              <li className="nav-item">
                <a href="/ArticleType" className="nav-link">Article Type</a>
              </li>
              <li id="current">
                <a href="/Author" className="nav-link">Author</a>
              </li>
              <li className="nav-item">
                <a href="/VolumeIssue" className="nav-link">Volume & Issue</a>
              </li>
            </ul>
          </div>
      </nav>
      <br/>
      <br/>
    <div className="container">

        <br/><br/><br/>

        <h4>Showing results for: {window.enteredText}</h4>
	  <p><i> Note: Search results may occur on subsequent pages of the issue</i></p>
	  <br/>
          {authors.map((item, index) => (
                <div key={index}>
                  {item[0].length > 0 ? (  //if we have a title
                <form action={"/ArticleResults/" + item[2]} method="GET">
                <button className="article-link" type="submit" >
                    <h3>{item[0]}</h3>
                </button>
                    <h4>{item[1]}</h4>
                    <br/>
                </form>
                    ) : (
                    <div>
                      <form action={"/ArticleResults/" + item[2]} method="GET">
                    <button className="article-link" type="submit">
                        <h3>Title Unknown</h3>
                    </button>
                        <h4>{item[1]}</h4>
                        <br/>
                    </form>
                    </div>)}

              {/* 0: title, 1: author, 2: id */}
                </div>
            ))}
    
    </div>
    </div>

  );
}
var authors = window.articlesList
const loopAuthors = Object.keys(authors).map(key => 
    <option value={key}>{authors[key]}</option>
)

export default AuthorList;
